import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Trash03 = function Trash03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 3h6M3 6h18m-2 0-.7013 10.5193c-.1052 1.5782-.1578 2.3674-.4987 2.9657a3 3 0 0 1-1.2983 1.2147C15.882 21 15.0911 21 13.5093 21h-3.0186c-1.5818 0-2.3727 0-2.9924-.3003A3 3 0 0 1 6.2 19.485c-.3409-.5983-.3935-1.3875-.4987-2.9657L5 6m5 4.5v5m4-5v5"
    })
  }));
};
export default Trash03;